import React from 'react';

import { Component as Landmark } from './Landmark.jsx';

class ArtworkGridContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false
        }

        this.containerRef = React.createRef();
    }
    componentDidMount() {
        this.setState({
            loaded: true
        });
    }
    render() {
        const props = this.props;
        const { loaded } = this.state;
        const children = React.Children.toArray(props.children);

        return (
            <div className="container--spaced__row container--spaced__row--extra" id={props.id} ref={this.containerRef}>
                {
                    loaded && (
                        children.map(child => React.cloneElement(child, { containerRef: () => this.containerRef.current }))
                    )
                }
                <div className="loading--waypoint">
                    <Landmark useWindow={true} onEnter={props.onWaypointEnter} />
                </div>
            </div>
        );
    }
}

function NoResults(props) {
    return (
        <TitleSpaced>
            <h4>{props.display}</h4>
        </TitleSpaced>
    );
}

function Onboarding(props) {
    return (
        <div className="pop--cont pop--persona pop--active">
            <div className="pop--persona__content">
                <div className="header-container text--center spacer--bottom">
                    <img alt="ArtCloud" className="sign__main__logo text--center" src="../assets/img/logos/header-mark-left.svg" />
                    <h5 className="sign__main__header--info">WELCOME!</h5>
                    {props.header}
                </div>
                {props.children}
            </div>
        </div>
    );
}

function Spaced(props) {
    let className = 'container container--spaced';
    if (props.className) {
        className += ' ' + props.className;
    }
    return (
        <div className={className} style={props.style}>
            {props.children}
        </div>
    );
}

function Section(props) {
    let className = 'section';
    if (props.className) {
        className += ' ' + props.className;
    }
    return (
        <div className={className} style={props.style}>
            {props.children}
        </div>
    );
}

class Tab extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        if (this.props.onClick) {
            this.props.onClick(event.currentTarget.dataset.tab);
        }
    }

    render() {
        const component = this;
        let tabs;
        if (component.props.tabs) {
            tabs = component.props.tabs.map(function (d) {
                let className = 'tabs__list__item';
                if (d.active) {
                    className += ' tabs__list__item__active';
                }
                return (
                    <a key={d.tab}
                        href={`#${d.tab}`}
                        className={className}
                        data-tab={d.tab}
                        onClick={component.handleClick}>
                        {d.label}
                    </a>
                );
            });
        }
        return (
            <div className="tabs">
                <div className="section">
                    <div className="container container--spaced">
                        <div className="tabs__list">
                            {tabs}
                        </div>
                        {this.props.tabExtras}
                    </div>
                </div>
                {this.props.children}
            </div>
        );
    }
}

function Title(props) {
    let className = 'section__title';
    if (props.small == true) {
        className += ' section__title--small';
    }
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <div className={className}>
            {props.children}
        </div>
    );
}

function TitleSpaced(props) {
    let className = 'section__title--medium';
    if (props.pad == true) {
        className += ' spacer--tmo';
    } else {
        className += ' spacer--bottom-m-none';
    }
    return (
        <Title className={className}>
            {props.children}
        </Title>
    );
}

function forResource(WrappedComponent, uri, slugOffset) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            let slug;
            const offset = slugOffset || 0;
            const pathComponents = location.pathname.split('/').filter(x => x);
            if (pathComponents && pathComponents.length > offset) {
                slug = pathComponents[pathComponents.length - (offset + 1)];
            }

            this.state = {
                slug: slug
            };

            this._get = this._get.bind(this);
            this.handleConfigureTabs = this.handleConfigureTabs.bind(this);
            this.handleRegisterRequestCallback = this.handleRegisterRequestCallback.bind(this);
            this.handleTabClick = this.handleTabClick.bind(this);
            this.handleUpdateData = this.handleUpdateData.bind(this);
        }

        componentWillUnmount() {
            if (this.request) {
                this.request.abort();
                this.request = null;
            }
        }

        _get(id) {
            const component = this;
            if (!uri || (!id && !component.state.slug)) {
                return;
            }
            component.request = Artcloud.api.get(
                uri(id || component.state.slug),
                null,
                function (responseData) {
                    component.request = null;

                    if (component.requestCallback) {
                        component.requestCallback(responseData);
                    }
                    component.setState({
                        data: responseData
                    });
                },
                function (jqXHR, textStatus) {
                    component.request = null;
                    Artcloud.api.fail(jqXHR, textStatus);
                }
            );
        }

        handleConfigureTabs(tabs, activeTab) {
            if (window.location.hash) {
                activeTab = window.location.hash.slice(1);

                tabs = tabs.map(function (d) {
                    d.active = d.tab == activeTab;
                    return d;
                });
            }

            this.setState({
                tab: activeTab,
                tabs: tabs
            });
        }

        handleRegisterRequestCallback(callback, sendRequest) {
            this.requestCallback = callback;

            if (sendRequest != false) {
                this._get();
            }
        }

        handleTabClick(tab) {
            const tabs = this.state.tabs.map(function (d) {
                d.active = d.tab == tab;
                return d;
            });
            this.setState({
                tab: tab,
                tabs: tabs
            });
        }

        handleUpdateData(data) {
            this.setState({
                data: data
            });
        }

        render() {
            return (
                <WrappedComponent
                    onConfigureTabs={this.handleConfigureTabs}
                    onRefresh={this._get}
                    onRegisterRequestCallback={this.handleRegisterRequestCallback}
                    onTabClick={this.handleTabClick}
                    onUpdateData={this.handleUpdateData}
                    {...this.state}
                    {...this.props}>
                    {this.props.children}
                </WrappedComponent>
            );
        }
    }
}

function withStripeTokenRequest(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.handleStripeTokenRequest = this.handleStripeTokenRequest.bind(this);
        }

        handleStripeTokenRequest(data, callback) {
            Artcloud.cashier.getToken(
                data.PaymentAccount,
                data.Expiration,
                data.CVC,
                data.Zip,
                function (status, response) {
                    if (!callback) {
                        return;
                    }
                    if (!response || response.error) {
                        let errorObj;
                        if (response.error && response.error.message) {
                            errorObj = { responseJSON: { Message: response.error.message } };
                        }
                        callback(false, errorObj);
                    } else {
                        callback(true, response);
                    }
                },
                function (jqXHR) {
                    if (!callback) {
                        return;
                    }
                    callback(false, jqXHR);
                }
            );
        }

        render() {
            return (
                <WrappedComponent onStripeTokenRequest={this.handleStripeTokenRequest} {...this.props}>
                    {this.props.children}
                </WrappedComponent>
            );
        }
    }
}

export {
    ArtworkGridContainer,
    NoResults,
    Onboarding,
    Spaced,
    Section,
    Tab,
    Title,
    TitleSpaced,
    forResource,
    withStripeTokenRequest
}